import { Inject, Injectable } from "@angular/core";
import { HttpService } from "../HttpClientServices/Http.service";
import { IScreen } from "BI-Libraries/BI-Interfaces/dist/bi-interfaces";
import { RecentScreensService } from "../RecentScreensService/recent-screens.service";
import { FavoriteScreensService } from "../favorite-screens.service";
import { TranslateService } from "@ngx-translate/core";
const browserType = /iPhone|iPad|iPod|Android|webOS|BlackBerry|Windows Phone/i.test(navigator.userAgent) ? 1 : 0;
@Injectable({
  providedIn: "root",
})
export class MenuItemsService {
  onTheFlyModulesIndexes = {favorite: 1, recent: 2};
  constructor(private httpService: HttpService, 
    private recentScreensService: RecentScreensService,
    private favoriteScreensService: FavoriteScreensService,
    private translateService: TranslateService,
    @Inject('UIUserProfile') private uiProfileService,

  ) {
    
  }
  InitMenuItems() {
    this.items = [];
     this.httpService.get(`api/MenuItem/GetMenuItem`).subscribe((response: any[]) => {
      this.items = response//.concat(this.ReportModule); 
      
      this.saveFavScreensAtLocalStorage(this.items.find(s => s.text == 'FavoritePages').children);
      this.subscribeToAddingFavoritePage();
      this.subscribeToRemovingFavoritePage();

      const RecentModule =
      {
        text: "RecentPages",
        icon: "assets/icons/carbon--recently-viewed.svg",
        children:[]
      };
      this.items.splice(this.onTheFlyModulesIndexes.recent, 0, RecentModule);
      
      this.setRecentPagesMenuItems();
      this.subscribeToNavigatedScreen();
    })

  }
  items: any[] = [];
  
    getReportManger() {
    return this.httpService.get('api/Report/GetReportsTree')
  }
//#region  FAVORITE PAGES HANDLERS
  private subscribeToAddingFavoritePage(){
    this.favoriteScreensService.addedFavoritePage$
    .subscribe((screen: IScreen) =>{
      if(screen == null)
        return;
      let favMenuItem = this.items.find(s => s.text == 'FavoritePages');
      if(!favMenuItem.children)
        favMenuItem.children = []
      favMenuItem.children.push({text: screen.PageName, path: screen.PageUrl})
    })
  }

  private subscribeToRemovingFavoritePage(){
    this.favoriteScreensService.deletedFavoritePage$
    .subscribe((screenUrl: string)=>{
      if(screenUrl == '')
        return;
      let favMenuItem = this.items.find(s => s.text == 'FavoritePages');
      if(favMenuItem)
        favMenuItem.children = this.favoriteScreensService.getLocalFavoritePagesFlattenedList().map(screen => ({text: screen.PageName, path: screen.PageUrl}));
      })
  }

  private saveFavScreensAtLocalStorage(favScreens :any[]){
    const convertedResult = favScreens.map(item => ({
      Id: item.Id,
      PageName: item.text,
      PageUrl: item.path
    }));
    this.resyncFavoritePages(convertedResult);
  }

  private resyncFavoritePages(pages: IScreen[]){
    const screensMap: Map<string, IScreen> = pages.reduce((map, screen) => {
      map.set(screen.PageUrl, screen);
      return map;
    }, new Map<string, IScreen>());
    this.favoriteScreensService.savePagesLocal(screensMap);
  }
//#endregion

//#region RECENT PAGES HANDLERS
  private setRecentPagesMenuItems(){ 
    let recentMenuItem = this.items.find(s => s.text == 'RecentPages');
    if(recentMenuItem)
      recentMenuItem.children = this.recentScreensService.getRecentPagesFlattenedList().map(screen => ({text: this.translateService.instant(screen.PageName), path: screen.PageUrl}));
  }

  public updateOrAddRecentPage(url: string, screenName): void { 
    if (url.startsWith('/')) {
      url = url.substring(1);
    }
    
    this.recentScreensService.addPageToRecent(url, screenName);
  }

//#endregion

//#region  GENERAL HELPER FUNCTIONS

  public subscribeToNavigatedScreen(){
    this.uiProfileService.recentPage$
    .subscribe((screen: IScreen) => {
      this.updateOrAddRecentPage(screen.PageUrl, screen.PageName);
       this.setRecentPagesMenuItems();
    })

  }
//#endregion
}
